import { memo } from "react";
import { Card, CardHeader, IconButton } from "@mui/material";
// cmps
import Svg from "../../svg";
// services
import { icons } from "@local/theme";
// types
import type { CSSProperties } from "react";
import type { CustomForceGraphNode } from "../../../types/misc";

const WRAPPER_STYLE = {
	position: "absolute",
	transform: "translate(-50%, -50%)",
	pointerEvents: "none",
	borderRadius: "4px",
	userSelect: "none",
} as const satisfies CSSProperties;

type Props = Readonly<{
	node: CustomForceGraphNode;
	posX: number;
	posY: number;
	isHighlighted: boolean;
	onCopyMacIdClick: (nodeId: string) => void;
}>;

const GraphDeviceNode = ({ node, posX, posY, isHighlighted, onCopyMacIdClick }: Props) => (
	<div style={{ ...WRAPPER_STYLE, left: posX, top: posY, border: isHighlighted ? "2px solid red" : "none" }}>
		<Card sx={{ backgroundColor: node.isGateway ? "#008fff" : node.isListedDevice ? "#8fbc8f" : "#808080" }}>
			<CardHeader
				avatar={<img src={node.icon} style={{ height: "40px", width: "40px" }} />}
				title={node.name}
				subheader={
					// MAC address with the device-list reachability icon inline next to it.
					// Keeping it here (rather than overlaid on the avatar) avoids MUI Card's
					// overflow:hidden clipping the badge and ties the status visually to
					// the identifier of the device.
					<span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
						{node.reachableStatus && <Svg src={`${node.reachableStatus}.svg`} size={14} />}
						<span>{node.id}</span>
					</span>
				}
				slotProps={{
					title: {
						noWrap: true,
						variant: "body2",
						style: {
							maxWidth: "140px",
							marginRight: "5px",
							fontWeight: "bold",
							color: "rgba(0, 0, 0, 0.870588)",
						},
					},
					subheader: {
						noWrap: true,
						variant: "body2",
						style: {
							color: "rgba(0, 0, 0, 0.870588)",
						},
					},
				}}
				action={
					<IconButton onClick={() => (onCopyMacIdClick(node.id))} sx={{ marginTop: "5px", pointerEvents: "auto" }}>
						<icons.CopyContent htmlColor="rgba(0, 0, 0, 0.870588)" />
					</IconButton>
				}
			/>
		</Card>
	</div>
);

export default memo(GraphDeviceNode);
